module.exports = __webpack_public_path__ + "media/popup.000129ca.png";